/* Greyon Virtual Try-On Studio: on-device lip try-on for every lip product and shade */
(function () {
  var VER = '0.10.14';
  window.GL_TS_BUILD = '20261023b';
  var CDN = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + VER;
  var MODEL = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';
  var MODEL_SHOP = 'https://cdn.shopify.com/s/files/1/0727/7998/9300/files/face_landmarker.task?v=1792752718';
  var OUTER = [61,185,40,39,37,0,267,269,270,409,291,375,321,405,314,17,84,181,91,146];
  var INNER = [78,191,80,81,82,13,312,311,310,415,308,324,318,402,317,14,87,178,88,95];
  var CKEY = 'gl-ts-col-v1:';

  function sampleColor(src, cb) {
    try { var c = sessionStorage.getItem(CKEY + src); if (c) { cb(c); return; } } catch (e) {}
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = 60, H = 60, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); x.drawImage(img, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, bins = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i] / 255, g = d[i + 1] / 255, b = d[i + 2] / 255;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2;
          var s = mx === mn ? 0 : (l > .5 ? (mx - mn) / (2 - mx - mn) : (mx - mn) / (mx + mn));
          if (mn > .9 || (mx < .22 && s < .5) || s < .18) continue;
          var h = 0;
          if (mx !== mn) { if (mx === r) h = ((g - b) / (mx - mn)) % 6; else if (mx === g) h = (b - r) / (mx - mn) + 2; else h = (r - g) / (mx - mn) + 4; h = (h * 60 + 360) % 360; }
          var k = Math.floor(h / 15) + '_' + (l < .42 ? 0 : 1);
          var bn = bins[k] || (bins[k] = { n: 0, r: 0, g: 0, b: 0 });
          bn.n++; bn.r += d[i]; bn.g += d[i + 1]; bn.b += d[i + 2];
        }
        var best = null; for (var key in bins) if (!best || bins[key].n > best.n) best = bins[key];
        if (!best || best.n < 10) return;
        var col = 'rgb(' + Math.round(best.r / best.n) + ',' + Math.round(best.g / best.n) + ',' + Math.round(best.b / best.n) + ')';
        try { sessionStorage.setItem(CKEY + src, col); } catch (e) {}
        cb(col);
      } catch (e) {}
    };
    img.src = src;
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var data = []; try { data = JSON.parse(root.querySelector('[data-gl-ts-data]').textContent); } catch (e) {}
    data = data.filter(function (p) { return p.shades && p.shades.length; });
    if (!data.length) return;
    var q = function (s) { return root.querySelector(s); };
    var canvas = q('[data-gl-ts-canvas]'), ctx = canvas.getContext('2d'), video = q('[data-gl-ts-video]');
    var start = q('[data-gl-ts-start]'), msg = q('[data-gl-ts-msg]'), tools = q('[data-gl-ts-tools]');
    var tabs = q('[data-gl-ts-tabs]'), shadesEl = q('[data-gl-ts-shades]'), range = q('[data-gl-ts-intensity]');
    var nameEl = q('[data-gl-ts-name]'), prodEl = q('[data-gl-ts-product]'), priceEl = q('[data-gl-ts-price]'), dotEl = q('[data-gl-ts-dot]');
    var shotEl = q('[data-gl-ts-img]'), tagEl = q('[data-gl-ts-tag]'), intVal = root.querySelector('[data-gl-int-val]'), addBtn = q('[data-gl-ts-add]'), viewLink = q('[data-gl-ts-view]');
    var addText = addBtn.textContent;
    var rail = q('[data-gl-ts-rail]'), countEl = q('[data-gl-ts-count]'), bar = q('[data-gl-ts-bar]'), prevBtn = q('[data-gl-ts-prev]'), nextBtn = q('[data-gl-ts-next]'), arrowsEl = q('[data-gl-ts-arrows]'), progEl = q('[data-gl-ts-progress]');
    var mask = document.createElement('canvas'), mctx = mask.getContext('2d');
    var landmarker = null, loading = null, mode = '', stream = null, raf = 0, photo = null, smooth = null, lastFace = 0, compare = false;
    var cur = { p: null, s: null, color: '#9e2a5c' };

    data.forEach(function (p) { p.shades.forEach(function (s) {
      s.color = /^(#|rgb|hsl)/.test(s.bg) ? s.bg : '';
      var m = /url\((['"]?)(.*?)\1\)/.exec(s.bg || '');
      if (!s.src && m) s.src = m[2];
      if (!s.color) s.color = '#b5586f';
    }); });

    var rubTabs = Array.prototype.slice.call(root.querySelectorAll('[data-gl-rub-val]'));
    function paintInt() {
      var rubWrap = root.querySelector('[data-gl-rub]');
      if (rubWrap && cur.color) rubWrap.style.setProperty('--rub-c', cur.color);
      rubTabs.forEach(function (t) { t.setAttribute('aria-checked', t.getAttribute('data-gl-rub-val') === String(range.value) ? 'true' : 'false'); });
    }
    function updateRail() {
      var max = rail.scrollWidth - rail.clientWidth;
      var over = max > 4;
      arrowsEl.hidden = !over; progEl.hidden = !over;
      var x = rail.scrollLeft;
      rail.classList.toggle('is-start', x <= 2);
      rail.classList.toggle('is-end', !over || x >= max - 2);
      prevBtn.disabled = x <= 2; nextBtn.disabled = !over || x >= max - 2;
      if (over) {
        var w = rail.clientWidth / rail.scrollWidth * 100;
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (x / max * (100 / w * 100 - 100)) + '%)';
      }
    }
    function showInRail(btn) {
      if (!btn) return;
      var l = btn.offsetLeft - shadesEl.offsetLeft, r = l + btn.offsetWidth;
      if (l < rail.scrollLeft + 24) rail.scrollTo({ left: Math.max(0, l - 40), behavior: 'smooth' });
      else if (r > rail.scrollLeft + rail.clientWidth - 24) rail.scrollTo({ left: r - rail.clientWidth + 40, behavior: 'smooth' });
    }
    function step(dir) { rail.scrollBy({ left: dir * Math.max(120, rail.clientWidth * 0.7), behavior: 'smooth' }); }
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(updateRail); }, { passive: true });
    window.addEventListener('resize', updateRail);
    shadesEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var all = Array.prototype.slice.call(shadesEl.querySelectorAll('.gl-ts__sw'));
      var i = all.indexOf(document.activeElement); if (i < 0) return;
      var n = all[Math.min(all.length - 1, Math.max(0, i + (e.key === 'ArrowRight' ? 1 : -1)))];
      e.preventDefault(); n.focus(); n.click();
    });
    // One gentle peek so shoppers see more shades sit off to the side
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var peeked = false;
      new IntersectionObserver(function (en, ob) {
        if (peeked || !en[0].isIntersecting) return;
        peeked = true; ob.disconnect();
        if (rail.scrollWidth - rail.clientWidth < 40 || rail.scrollLeft > 2) return;
        setTimeout(function () {
          rail.scrollTo({ left: 72, behavior: 'smooth' });
          setTimeout(function () { rail.scrollTo({ left: 0, behavior: 'smooth' }); }, 700);
        }, 500);
      }, { threshold: 0.6 }).observe(rail);
    }
    function say(k) { if (!k) { msg.hidden = true; return; } msg.textContent = msg.getAttribute('data-' + k) || msg.getAttribute('data-error'); msg.hidden = false; }

    function pickShade(s, btn) {
      cur.s = s; cur.color = s.color;
      nameEl.textContent = s.name; prodEl.textContent = cur.p.title; priceEl.textContent = s.price;
      dotEl.style.background = s.color; tagEl.style.background = s.color; paintInt();
      var all = shadesEl.querySelectorAll('.gl-ts__sw');
      all.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
      countEl.textContent = (Array.prototype.indexOf.call(all, btn) + 1) + ' / ' + all.length;
      showInRail(btn);
      viewLink.href = cur.p.url + '?variant=' + s.id;
      addBtn.disabled = !s.ok; addBtn.textContent = s.ok ? addText : addBtn.getAttribute('data-soldout');
      if (mode === 'photo') render();
    }
    function pickProduct(p, tab) {
      cur.p = p;
      if (p.img) { shotEl.src = p.img; shotEl.hidden = false; } else { shotEl.hidden = true; }
      tabs.querySelectorAll('.gl-ts__tab').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      range.value = 30; paintInt();
      shadesEl.innerHTML = '';
      var first = null, firstBtn = null;
      p.shades.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'gl-ts__sw' + (s.ok ? '' : ' is-out'); b.setAttribute('role', 'option');
        b.setAttribute('aria-label', s.name); b.title = s.name;
        var sp = document.createElement('span'); sp.style.background = s.color; b.appendChild(sp);
        b.addEventListener('click', function () { pickShade(s, b); });
        shadesEl.appendChild(b);
        if (s.src && !s.sampled) {
          s.sampled = true;
          sampleColor(s.src, function (c) { s.color = c; sp.style.background = c; if (cur.s === s) { cur.color = c; dotEl.style.background = c; tagEl.style.background = c; paintInt(); if (mode === 'photo') render(); } });
        }
        if (!first && s.ok) { first = s; firstBtn = b; }
      });
      if (!first) { first = p.shades[0]; firstBtn = shadesEl.firstChild; }
      rail.scrollLeft = 0; updateRail();
      pickShade(first, firstBtn);
    }
    data.forEach(function (p, i) {
      var t = document.createElement('button');
      t.type = 'button'; t.className = 'gl-ts__tab'; t.setAttribute('role', 'tab'); t.textContent = p.title; var cnt = document.createElement('small'); cnt.textContent = p.shades.length; cnt.setAttribute('aria-hidden', 'true'); t.appendChild(cnt);
      t.addEventListener('click', function () { pickProduct(p, t); });
      tabs.appendChild(t);
      if (i === 0) pickProduct(p, t);
    });

    // Face model loads ONLY when the shopper opens the try-on (no page-speed cost).
    // Model file is served from Shopify's own CDN; script/wasm try several mirrors in case one is blocked by an ISP.
    var MP_HOSTS = ['https://fastly.jsdelivr.net/npm/@mediapipe/tasks-vision@' + VER, 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + VER, 'https://unpkg.com/@mediapipe/tasks-vision@' + VER, 'https://gcore.jsdelivr.net/npm/@mediapipe/tasks-vision@' + VER];
    var MP_MODELS = [MODEL_SHOP, MODEL];
    function loadModel() {
      if (loading) return loading;
      var make = function (v, fs, mi) {
        var o = function (d) { return { baseOptions: { modelAssetPath: MP_MODELS[mi], delegate: d }, runningMode: 'VIDEO', numFaces: 1 }; };
        return v.FaceLandmarker.createFromOptions(fs, o('GPU')).catch(function () { return v.FaceLandmarker.createFromOptions(fs, o('CPU')); })
          .catch(function (e) { if (mi + 1 < MP_MODELS.length) return make(v, fs, mi + 1); throw e; });
      };
      var tryHost = function (i) {
        return import(MP_HOSTS[i] + '/vision_bundle.mjs').then(function (v) {
          return v.FilesetResolver.forVisionTasks(MP_HOSTS[i] + '/wasm').then(function (fs) { return make(v, fs, 0); });
        }).catch(function (e) { if (i + 1 < MP_HOSTS.length) return tryHost(i + 1); throw e; });
      };
      loading = tryHost(0).then(function (lm) { landmarker = lm; return lm; });
      loading.catch(function () { loading = null; });
      return loading;
    }
    function lipPath(c, pts, w, h) {
      c.beginPath();
      [OUTER, INNER].forEach(function (ring) {
        ring.forEach(function (i, k) { var p = pts[i]; if (k) c.lineTo(p.x * w, p.y * h); else c.moveTo(p.x * w, p.y * h); });
        c.closePath();
      });
    }
    // Studio light: auto-exposure lifts dim/backlit faces (measured on a tiny frame, cheap), gentle glow, real skin tone kept
    var soft = document.createElement('canvas'), sctx = soft.getContext('2d', { willReadFrequently: true });
    var gLum = 0.5, gGain = 1.1, gN = 0;
    function drawBeauty(src, w, h) {
      var sw = Math.max(1, Math.round(w / 10)), sh = Math.max(1, Math.round(h / 10));
      if (soft.width !== sw || soft.height !== sh) { soft.width = sw; soft.height = sh; }
      sctx.drawImage(src, 0, 0, sw, sh);
      var still = src.tagName === 'IMG';
      if (still || gN++ % 8 === 0) {
        try {
          // weight the centre (where the face is) so a bright window behind does not fool it
          var x0 = Math.round(sw * 0.25), y0 = Math.round(sh * 0.15), cw = Math.max(1, Math.round(sw * 0.5)), ch = Math.max(1, Math.round(sh * 0.6));
          var d = sctx.getImageData(x0, y0, cw, ch).data, s = 0, n = 0;
          for (var i = 0; i < d.length; i += 8) { s += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
          if (n) gLum = s / n / 255;
        } catch (e) {}
      }
      var want = Math.min(1.7, Math.max(1.04, 0.56 / Math.max(gLum, 0.12)));
      gGain = still ? want : gGain + (want - gGain) * 0.15;
      ctx.filter = 'brightness(' + gGain.toFixed(3) + ') contrast(' + (gGain > 1.3 ? 0.94 : 0.97) + ') saturate(1.06)';
      ctx.drawImage(src, 0, 0, w, h);
      ctx.filter = 'none';
      ctx.save();
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = 0.06; ctx.drawImage(soft, 0, 0, w, h);
      ctx.restore();
    }
    // Natural colour: even 100% stays wearable, never a painted-on block
    function lipAlpha() { return 0.26 + (range.value / 100) * 0.72; }
    function paintLips(pts, w, h) {
      if (compare || !pts) return;
      if (mask.width !== w || mask.height !== h) { mask.width = w; mask.height = h; }
      mctx.clearRect(0, 0, w, h);
      mctx.filter = 'blur(' + Math.max(1, w / 480).toFixed(1) + 'px)';
      mctx.fillStyle = cur.color; lipPath(mctx, pts, w, h); mctx.fill('evenodd');
      mctx.filter = 'none';
      var a = lipAlpha();
      ctx.save();
      ctx.globalCompositeOperation = 'color'; ctx.globalAlpha = Math.min(1, a * 0.75); ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = 'multiply'; ctx.globalAlpha = a * 0.5; ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = 'soft-light'; ctx.globalAlpha = a * 0.35; ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = a * 0.3; ctx.drawImage(mask, 0, 0);
      ctx.restore();
    }
    function smoothPts(pts) {
      if (!smooth || smooth.length !== pts.length) { smooth = pts.map(function (p) { return { x: p.x, y: p.y }; }); return smooth; }
      for (var i = 0; i < pts.length; i++) { smooth[i].x += (pts[i].x - smooth[i].x) * .6; smooth[i].y += (pts[i].y - smooth[i].y) * .6; }
      return smooth;
    }
    function loop() {
      raf = requestAnimationFrame(loop);
      if (video.readyState < 2) return;
      var w = video.videoWidth, h = video.videoHeight;
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
      ctx.save(); ctx.translate(w, 0); ctx.scale(-1, 1); drawBeauty(video, w, h);
      var pts = null;
      if (landmarker) { try { var r = landmarker.detectForVideo(video, performance.now()); if (r.faceLandmarks && r.faceLandmarks[0]) pts = smoothPts(r.faceLandmarks[0]); } catch (e) {} }
      paintLips(pts, w, h); ctx.restore();
      if (landmarker) { if (pts) { lastFace = Date.now(); if (!msg.hidden) say(''); } else if (Date.now() - lastFace > 1200) say('noface'); }
    }
    function stopAll() {
      cancelAnimationFrame(raf); raf = 0; smooth = null;
      if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
      video.srcObject = null; mode = ''; tools.hidden = true;
    }
    function reset() { stopAll(); photo = null; start.hidden = false; say(''); ctx.clearRect(0, 0, canvas.width, canvas.height); }
    function startCamera() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { say('error'); return; }
      stopAll(); say('loading');
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 960 } }, audio: false }).then(function (st) {
        stream = st; video.srcObject = st; return video.play();
      }).then(function () {
        mode = 'camera'; start.hidden = true; tools.hidden = false; lastFace = Date.now(); loop();
        loadModel().then(function (lm) { return lm.setOptions({ runningMode: 'VIDEO' }); }).catch(function () { if (mode === 'camera') say('model'); });
      }).catch(function () { stopAll(); start.hidden = false; say('error'); });
    }
    function render() {
      if (!photo) return;
      var w = photo.naturalWidth, h = photo.naturalHeight, k = Math.min(1, 1400 / Math.max(w, h));
      w = Math.round(w * k); h = Math.round(h * k);
      canvas.width = w; canvas.height = h; drawBeauty(photo, w, h); paintLips(photo._pts, w, h);
    }
    function startPhoto(file) {
      stopAll();
      var img = new Image();
      img.onload = function () {
        photo = img; mode = 'photo'; start.hidden = true; tools.hidden = false; render(); say('loading');
        loadModel().then(function (lm) { return lm.setOptions({ runningMode: 'IMAGE' }).then(function () { return lm; }); }).then(function (lm) {
          var r = lm.detect(img); photo._pts = r.faceLandmarks && r.faceLandmarks[0] ? r.faceLandmarks[0] : null;
          say(photo._pts ? '' : 'noface'); render();
        }).catch(function () { say('error'); });
      };
      img.src = URL.createObjectURL(file);
    }

    q('[data-gl-ts-camera]').addEventListener('click', startCamera);
    q('[data-gl-ts-file]').addEventListener('change', function (e) { var f = e.target.files && e.target.files[0]; if (f) startPhoto(f); e.target.value = ''; });
    q('[data-gl-ts-stop]').addEventListener('click', reset);
    rubTabs.forEach(function (t, i) {
      t.addEventListener('click', function () { range.value = t.getAttribute('data-gl-rub-val'); paintInt(); if (mode === 'photo') render(); });
      t.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return; e.preventDefault();
        var nx = rubTabs[(i + d + rubTabs.length) % rubTabs.length]; nx.focus(); nx.click();
      });
    });
    var cmp = q('[data-gl-ts-compare]');
    var setCmp = function (v) { return function (e) { e.preventDefault(); compare = v; cmp.classList.toggle('is-on', v); if (mode === 'photo') render(); }; };
    cmp.addEventListener('pointerdown', setCmp(true));
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { cmp.addEventListener(ev, setCmp(false)); });
    q('[data-gl-ts-snap]').addEventListener('click', function () {
      try { var a = document.createElement('a'); a.href = canvas.toDataURL('image/jpeg', .92); a.download = 'greyon-' + (cur.s ? cur.s.name : 'look').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.jpg'; document.body.appendChild(a); a.click(); a.remove(); } catch (e) {}
    });
    addBtn.addEventListener('click', function () {
      if (!cur.s || !cur.s.ok) return;
      addBtn.disabled = true;
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: cur.s.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          addBtn.textContent = addBtn.getAttribute('data-added');
          if (window.GreyonCart && window.GreyonCart.open) window.GreyonCart.open(); else document.dispatchEvent(new CustomEvent('gl:cart:open'));
          setTimeout(function () { addBtn.textContent = addText; addBtn.disabled = false; }, 2200);
        })
        .catch(function () { addBtn.disabled = false; window.location.href = viewLink.href; });
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden && mode === 'camera') reset(); });
  }

  function boot() { document.querySelectorAll('[data-gl-ts]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
